var exports = {
  "Nr": "AccountSecurityCard.module__card___dDAxaV",
  "nL": "AccountSecurityCard.module__headerless___dDAxaV",
  "Ge": "AccountSecurityCard.module__rows___dDAxaV",
  "wx": "AccountSecurityCard.module__header___dDAxaV",
  "TK": "AccountSecurityCard.module__headerText___dDAxaV",
  "$": "AccountSecurityCard.module__titleRow___dDAxaV",
  "DD": "AccountSecurityCard.module__title___dDAxaV",
  "h_": "AccountSecurityCard.module__description___dDAxaV",
  "QE": "AccountSecurityCard.module__headerAction___dDAxaV",
  "nM": "AccountSecurityCard.module__row___dDAxaV",
  "qg": "AccountSecurityCard.module__rowText___dDAxaV",
  "xZ": "AccountSecurityCard.module__rowLabel___dDAxaV",
  "Z$": "AccountSecurityCard.module__rowDescription___dDAxaV",
  "TF": "AccountSecurityCard.module__rowWarning___dDAxaV",
  "cm": "AccountSecurityCard.module__rowActions___dDAxaV",
  "OL": "AccountSecurityCard.module__emptyRow___dDAxaV",
  "xH": "AccountSecurityCard.module__switchRow___dDAxaV",
};

module.exports = exports;
